import React, { useEffect, useState, useContext } from 'react';
import {
    Upload,
    message,
    Row,
    Col,
    Card,
    Button,
    Typography,
    Modal,
    List,
    Spin,
    Tooltip
} from 'antd';

import { AppContext } from 'context/AppContext';
import ClientTable from 'components/content/homeView/ClientTable.js';
import HeaderHome from 'components/header/HeaderHome';

import icon_cloud_upload from 'images/icon_cloud_upload.svg';
import { useNavigate } from 'react-router-dom';

import icon_note from 'images/icon_note.svg';
import icon_note_blue from 'images/new_note_icon.svg';
import new_circle from 'images/new_pop_ups/new_circle.svg';

import { getPreloadedDataset, addPreloadedFile } from 'services/home';
import { getHelpItem } from 'services/help';

import cloneDeep from 'lodash/cloneDeep';

import HelpMenu from 'components/navigation/HelpMenu';

import notice from 'images/new_pop_ups/notice.svg';
import Loader from 'components/Loader';
import DelayedDataProcessing from './Upload/popups/DelayedDataProcessing';
import AbortDataProcessing from './Upload/popups/AbortDataProcessing';
import CartsAndTableView from 'components/modal/tutorial/CartsAndTableView';
import MyProjects from 'components/modal/tutorial/MyProjects';
import Navigation from 'components/modal/tutorial/Navigation';
import { changeDefaults } from 'services/login';

// import { PDFDownloadLink } from '@react-pdf/renderer';
// import PDFFile from 'components/PDF/PDFFile';

const { Dragger } = Upload;
const { Title } = Typography;

const HomeView = () => {
    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const getWindowSize = () => {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    };

    const [windowSize, setWindowSize] = useState(getWindowSize());

    const appContext = useContext(AppContext);

    const most_recent_name = appContext.defaults.most_recent
        ? appContext.defaults.most_recent.name
        : null;
    const most_recent_id = appContext.defaults.most_recent
        ? appContext.defaults.most_recent.id
        : null;
    const most_recent_file_name = appContext.defaults.most_recent
        ? appContext.defaults.most_recent.file_name
        : null;

    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisiblePreloaded, setIsModalVisiblePreloaded] =
        useState(false);
    const [projectIdNumber, setProjectIdNumber] = useState();
    const [uploadedFileName, setUploadedFileName] = useState();

    const [spinnerPreloadedDataset, setSpinnerPreloadedDataset] =
        useState(false);

    const [isModalVisibleOops, setIsModalVisibleOops] = useState(false);

    const handleOk = () => {
        navigate(`/setheaderrow/${projectIdNumber}`);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const showModalPreloaded = () => {
        setIsModalVisiblePreloaded(true);
    };

    const handleOkPreloaded = () => {
        setIsModalVisiblePreloaded(false);
    };

    const handleCancelPreloaded = () => {
        setIsModalVisiblePreloaded(false);
    };

    const showModalOops = () => {
        setIsModalVisibleOops(true);
    };

    const handleOkOops = () => {
        setIsModalVisibleOops(false);
    };

    const [fileName, setFileName] = useState('file');
    const [multiple, setMultiple] = useState(false);
    const [action, setAction] = useState(
        process.env.REACT_APP_API_URL + '/api/v1/file/'
    );
    useEffect(() => {
        appContext.setCurrentLocation(['1']);
    }, []);

    const [clickedIdSpinner, setClickedIdSpinner] = useState(null);

    const [preloadedDataset, setPreloadedDataset] = useState(null);

    const [preloadedDatasetFinish, setPreloadedDatasetFinish] = useState(true);

    let navigate = useNavigate();

    const uploadStatus = (info) => {
        const { status } = info.file;
        if (status !== 'uploading') {
        }
        if (status === 'done') {
            setUploadedFileName(info.file.name);

            const projectId = info.fileList[0].response.id;
            if (projectId !== undefined) {
                setProjectIdNumber(projectId);
                setIsFileUploaded(false);
                setTimeout(() => {
                    setIsModalVisible(true);
                }, 300);
            } else {
                setIsFileUploaded(false);
                showModalOops();
            }
        } else if (status === 'error') {
            message.error(`file upload failed. Please try again`);
            setIsFileUploaded(false);
        }
    };

    const onPreview = () => {
        setIsFileUploaded(true);
    };

    function beforeUpload(file) {
        setIsFileUploaded(true);
        const isExcel =
            file.type ===
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            file.type === 'application/vnd.ms-excel' ||
            file.type === 'text/csv';
        if (!isExcel) {
            message.error('You can only upload XLS/XLSX/CSV file!');
        }
        const fileSizeLimit = file.size / 1024 / 1024 < 55;
        if (!fileSizeLimit) {
            message.error('File must be less than 55MB!');
        }

        return isExcel && fileSizeLimit;
    }

    const uploadDrop = (e) => {
        setIsFileUploaded(true);
    };

    const [helpStructureMenu, setHelpStructureMenu] = useState();

    useEffect(() => {
        getPreloadedDataset().then((res) => {
            setPreloadedDataset(res.data.results);
        });
        // }, [spinnerPreloadedDataset]);
    }, [isModalVisiblePreloaded]);

    useEffect(() => {
        getHelpItem().then((res) => {
            let results = res.data.results;

            setHelpStructureMenu(results);
        });
    }, []);

    let copyPreloadedDataset = cloneDeep(preloadedDataset);

    let mapPreloadedDataset = '';

    let closeSpinner = () => {
        setSpinnerPreloadedDataset(false);
        handleCancelPreloaded();
    };

    if (copyPreloadedDataset !== null) {
        mapPreloadedDataset = copyPreloadedDataset.map((item) => {
            return (
                <div key={item.name} className="card-preloaded">
                    <div className="left-content">
                        <div className="title">{item.name}</div>
                        <div className="description">{item.description}</div>
                    </div>
                    <div className="right-content">
                        <div
                            className="button"
                            onClick={() => {
                                if (item.downloaded === false) {
                                    addPreloadedFile(item.id).then((res) => {
                                        setTimeout(closeSpinner, 1000);
                                        setPreloadedDatasetFinish(
                                            !preloadedDatasetFinish
                                        );
                                    });

                                    setSpinnerPreloadedDataset(true);
                                    setClickedIdSpinner(item.id);
                                }
                            }}
                        >
                            {' '}
                            {item.downloaded === false ? (
                                'Open'
                            ) : (
                                <div className="disabled">Opened</div>
                            )}
                            {item.id === clickedIdSpinner &&
                            spinnerPreloadedDataset ? (
                                <div className="lds-dual-ring-small-preloaded"></div>
                            ) : (
                                <div></div>
                            )}
                        </div>
                    </div>
                </div>
            );
        });
    }

    return (
        <>
            {appContext.helpNavIsVisible ? <HelpMenu /> : null}
            <HeaderHome />
            <Row
                justify="space-around"
                style={{ marginTop: 20 }}
                // gutter={400}
                className="home-headerr"
            >
                <Col sm={12} md={7} lg={7}>
                    <Title level={4} className="title-in-card-home">
                        Preloaded Datasets
                    </Title>
                    <Card bordered={true} className="card-box blank-body-box">
                        <Row align="center">
                            <img
                                // src={preloaded_icon}
                                src={icon_note_blue}
                                className="preloaded-icon-svg"
                            />
                        </Row>
                        <Row align="center">
                            <Button
                                className="blue-button"
                                type="primary"
                                onClick={showModalPreloaded}
                            >
                                OPEN
                            </Button>
                        </Row>
                    </Card>
                </Col>

                <Col sm={12} md={7} lg={7}>
                    <Title level={4} className="title-in-card-home">
                        Upload Dataset
                    </Title>
                    <Card bordered={true} className="card-box upload-body-box">
                        <Dragger
                            onChange={uploadStatus}
                            onDrop={uploadDrop}
                            onPreview={onPreview}
                            file={fileName}
                            multiple={multiple}
                            beforeUpload={beforeUpload}
                            action={action}
                            style={{ width: '100%', height: '100%' }}
                            showUploadList={false}
                            accept=".xls,.xlsx,.csv"
                            headers={{
                                Authorization: `Bearer ${sessionStorage.getItem(
                                    'accessToken'
                                )}`
                            }}
                        >
                            {isFileUploaded ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '100%',
                                        height: '100%'
                                    }}
                                >
                                    <Loader />
                                </div>
                            ) : (
                                <>
                                    <div
                                        className="upload-body-box-title"
                                        style={{ marginTop: '11px' }}
                                    >
                                        <div style={{ color: '#3D5253' }}>
                                            Drag and drop files here or
                                        </div>
                                        <div
                                            style={{
                                                textDecoration: 'underline',
                                                color: '#407CB1',
                                                marginLeft: '4px'
                                            }}
                                        >
                                            choose a file
                                        </div>
                                    </div>
                                    <div className="">
                                        <img
                                            src={icon_cloud_upload}
                                            className="icon-cloud-upload-svg"
                                            style={{ marginBottom: '10px' }}
                                        />
                                    </div>
                                    <Button
                                        className="blue-button"
                                        type="primary"
                                        onClick={() => {}}
                                    >
                                        UPLOAD
                                    </Button>
                                </>
                            )}
                        </Dragger>
                    </Card>
                </Col>

                <Col sm={12} md={7} lg={7}>
                    <Title level={4} className="title-in-card-home">
                        New Dataset
                    </Title>
                    <Card bordered={true} className="card-box most-recent-box">
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                height: '100%',
                                justifyContent: 'end'
                            }}
                        >
                            <svg
                                style={{ marginBottom: '35px' }}
                                width="60"
                                height="60"
                                viewBox="0 0 60 60"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M30 55V30M30 30V5M30 30H55M30 30H5"
                                    stroke="#407CB1"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <Button
                                className="blue-button"
                                type="primary"
                                onClick={() => {
                                    navigate(`/manualdata/`);
                                }}
                                style={{ marginBottom: '30px' }}
                            >
                                NEW
                            </Button>
                        </div>
                    </Card>
                </Col>
            </Row>
            {/* <Col sm={12} md={7} lg={7}>
                    <Title level={4} className="title-in-card-home">
                        Most Recent
                    </Title>
                    <Card bordered={true} className="card-box most-recent-box">
                        <Row
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                textAlign: 'center'
                            }}
                        >
                            {most_recent_name == null ? (
                                ''
                            ) : (
                                <div>
                                    <Col>
                                        <div
                                            className="most-recent-box-title"
                                            style={
                                                windowSize.innerWidth < 1000 &&
                                                most_recent_file_name.length <
                                                    11
                                                    ? { marginTop: '7px' }
                                                    : { marginTop: '0px' }
                                            }
                                        >
                                            {most_recent_name}
                                        </div>
                                    </Col>
                                    <Col>
                                        <div
                                            className="most-recent-box-project-name"
                                            style={{ paddingTop: 20 }}
                                        >
                                            <Tooltip
                                                placement="top"
                                                title={most_recent_file_name}
                                            >
                                                {windowSize.innerWidth < 1000 &&
                                                most_recent_file_name.length >=
                                                    5
                                                    ? most_recent_file_name.substring(
                                                          0,
                                                          24
                                                      ) + '...'
                                                    : null}

                                                {windowSize.innerWidth >=
                                                    1000 &&
                                                windowSize.innerWidth <= 1400 &&
                                                most_recent_file_name.length >=
                                                    5
                                                    ? most_recent_file_name.substring(
                                                          0,
                                                          33
                                                      ) + '...'
                                                    : null}

                                                {windowSize.innerWidth >= 1401
                                                    ? most_recent_file_name.substring(
                                                          0,
                                                          50
                                                      ) +
                                                      ` ${
                                                          most_recent_file_name.length >
                                                          50
                                                              ? '...'
                                                              : ''
                                                      } `
                                                    : null}
                                            </Tooltip>
                                        </div>
                                    </Col>
                                </div>
                            )}
                            {most_recent_name == null ? (
                                <div className="container-empty-most-recent">
                                    <Col>
                                        <List style={{ height: '50px' }} />
                                    </Col>
                                </div>
                            ) : (
                                ''
                            )}
                        </Row>

                        <Row>
                            <Col>
                                <div></div>
                            </Col>
                        </Row>
                        {most_recent_name == null ? (
                            ''
                        ) : (
                            <Button
                                className="blue-button"
                                type="primary"
                                onClick={() => {
                                    navigate(`/project/${most_recent_id}`);
                                }}
                            >
                                OPEN
                            </Button>
                        )}
                    </Card>
                </Col>
            </Row> */}
            <ClientTable preloadedDatasetFinish={preloadedDatasetFinish} />
            {/* <PDFDownloadLink document={<PDFFile />} fileName="FORM">
                {({ loading }) =>
                    loading ? (
                        <button>Loading document...</button>
                    ) : (
                        <button>Download</button>
                    )
                }
            </PDFDownloadLink> */}
            {/* <MyProjects />
            <ChartsAndTableView /> */}
            {/* <Table
                columns={columnsTest}
                dataSource={dataScroll}
                components={vt}
                pagination={false}
                loading={loadingScroll}
                scroll={{
                    scrollToFirstRowOnChange: false,
                    y: 300
                }}
            /> */}
            {/* <TableScroll /> */}
            <Modal
                className="basic-modal-legal-notice"
                title=""
                visible={isModalVisibleOops}
                onCancel={handleOkOops}
                footer={null}
                closable={false}
                bodyStyle={{ minHeight: 330 }}
                width={380}
            >
                <div className="icon-container">
                    {/* <img
                        className="img-icon-container"
                        src={background_circle_red_modal}
                    />
                    <img
                        className="icon-in-green-circle"
                        src={icon_in_red_circle}
                    /> */}
                    <img
                        src={notice}
                        style={{
                            position: 'absolute',
                            top: '-50px',
                            left: '-50px'
                        }}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '262px',
                        justifyContent: 'space-between'
                    }}
                >
                    <div style={{ padding: '8px 0 0 0', marginLeft: 6 }}>
                        <p
                            className="header-title"
                            style={{ marginBottom: '30px' }}
                        >
                            Oops..
                        </p>
                        <p
                            style={{
                                fontFamily: 'Roboto Regular',
                                fontSize: '16px',
                                lineHeight: '22px'
                            }}
                        >
                            Something went wrong..
                        </p>
                        <p
                            style={{
                                fontFamily: 'Roboto Regular',
                                fontSize: '16px',
                                lineHeight: '22px',
                                marginTop: '50px'
                            }}
                        >
                            Please try again loading yor data.<br></br>
                        </p>
                    </div>
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: 22,
                            padding: '0 5px',
                            marginBottom: '6px'
                        }}
                    >
                        <button
                            onClick={() => {
                                handleOkOops();
                            }}
                            // style={{ width: 223 }}
                            className="ant-btn ant-btn-primary ant-btn-block blue-button"
                        >
                            OK
                        </button>
                        {/* <Button
                            onClick={handleCancel}
                            style={{
                                width: '100%',
                                marginTop: 10,
                                borderColor: '#578cba',
                                color: '#578cba'
                            }}
                        >
                            DECLINE AND GO BACK
                        </Button> */}
                    </div>
                </div>
            </Modal>
            <Modal
                className="basic-modal-legal-notice"
                title=""
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
                closable={false}
                bodyStyle={{ minHeight: 500 }}
                width={331}
            >
                <div className="icon-container">
                    {/* <img
                        className="img-icon-container"
                        src={background_circle_red_modal}
                    />
                    <img
                        className="icon-in-green-circle"
                        src={icon_in_red_circle}
                    /> */}
                    <img
                        src={notice}
                        style={{
                            position: 'absolute',
                            top: '-50px',
                            left: '-50px'
                        }}
                    />
                </div>
                <div>
                    <div style={{ padding: '8px 0 0 0', marginLeft: 6 }}>
                        <p
                            className="header-title"
                            style={{ marginBottom: '30px' }}
                        >
                            Legal Notice
                        </p>
                        <p
                            style={{
                                fontFamily: 'Roboto Regular',
                                fontSize: '16px',
                                lineHeight: '22px'
                            }}
                        >
                            {/* By clicking “Agree and Upload” you
                            <br />
                            declare that you are the rightful owner
                            <br />
                            of this file and permit Econometrica to <br />
                            store it on our servers.{' '} */}
                            By clicking the “Agree and Upload” <br />
                            button you are declaring you are <br />
                            the rightful owner of this file and <br />
                            are in effect giving Econometrica <br />
                            permission to store it on our <br />
                            servers. Econometrica does not <br />
                            carry any liability for your misuse <br />
                            of this information.
                        </p>

                        <p
                            style={{
                                marginTop: 20,
                                fontFamily: 'Roboto Regular',
                                fontSize: '16px',
                                lineHeight: '22px'
                            }}
                        >
                            {/* Econometrica does not carry any <br />
                            liability if you misuse the uploaded file.{' '} */}
                            If you do not wish to upload, <br />
                            Econometrica will not be able to <br />
                            process your file and assist you <br />
                            with any analyses.
                        </p>
                    </div>
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: 22,
                            padding: '0 5px',
                            marginBottom: '6px'
                        }}
                    >
                        <button
                            onClick={handleOk}
                            // style={{ width: 223 }}
                            className="ant-btn ant-btn-primary ant-btn-block blue-button"
                        >
                            AGREE AND UPLOAD
                        </button>
                        <Button
                            onClick={handleCancel}
                            style={{
                                width: '100%',
                                marginTop: 10,
                                borderColor: '#578cba',
                                color: '#578cba'
                            }}
                        >
                            DECLINE AND GO BACK
                        </Button>
                    </div>
                </div>
            </Modal>
            <Modal
                className="custom-modal-preloaded-datasets"
                title=""
                visible={isModalVisiblePreloaded}
                onOk={handleOkPreloaded}
                onCancel={handleCancelPreloaded}
                footer={null}
                closable={false}
                bodyStyle={{ minHeight: 415 }}
                width={650}
            >
                <div className="header">
                    <div className="title">Preloaded Datasets</div>

                    {/* <div className="close-btn">
                        <img
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                handleCancelPreloaded();
                            }}
                            src={icon_close}
                        />
                    </div> */}
                    <div
                    // style={{ position: 'absolute', top: 0, right: '-40px' }}
                    // className="icon-container"
                    >
                        {/* <img
                            className="img-icon-container"
                            src={backgroung_circle_blue_preloaded}
                        />
                        <img className="icon-in-green-circle" src={icon_note} /> */}
                        <img
                            src={new_circle}
                            style={{
                                position: 'absolute',
                                top: '-50px',
                                right: '-49px'
                            }}
                        />
                        <img
                            src={icon_note}
                            style={{
                                zIndex: 0,
                                top: '-20px',
                                position: 'absolute',
                                right: '-19px'
                            }}
                        />
                    </div>
                </div>
                <div className="head-description">
                    Download datasets and start using Economentrica’s powerful
                    analytical tools.
                </div>
                <div className="preloaded-dataset">{mapPreloadedDataset}</div>
            </Modal>
            {appContext.defaults.onboarding_home == 'finish' ? null : (
                <MyProjects />
            )}
            <DelayedDataProcessing />
        </>
    );
};

export default HomeView;
